import { createSelector } from 'reselect';
import { RefundState } from '../../types';

export const getState = (state: RefundState) => state.refundInfo;
export const getSelectedReason = (state: RefundState) => state.reason;

export const getIsDocumentConfirmationRequired = createSelector(
	getState,
	refundInfo => refundInfo.confirmationDocsAreRequired
);

export const getPrices = createSelector(getState, refundInfo => refundInfo.prices);

export const getReasonsInfo = createSelector([getState], refundInfo => refundInfo.unvoluntaryReasonsInfo);

export const getIsDocUploadRequired = createSelector(
	[getState, getSelectedReason],
	(refundInfo, selectedReason) => refundInfo.confirmationDocsAreRequired && selectedReason.docs.length > 0
);

export const getNasServices = createSelector([getState], refundInfo => refundInfo.additionalServices?.nas);
